import styled from 'styled-components'
import { Media } from '../../style'

const AdaptationSection = styled.section`
  ${Media.lessThan(Media.small)} {
    height: 1006px;
  }
`
export default AdaptationSection
